import RoutesMap from '../../route_control/RouteControl.js'
import {
    ScheduleList,
    AddSchedule,
    UpdateSchedule
} from '../../pages/online_class'

export const OnlineClassImport = {
    RoutesMap,
    ScheduleList,
    AddSchedule,
    UpdateSchedule
}
